import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../../pipes/pipes.module';
import { GenericDirectivesModule } from '../../generic-directives/generic-directives.module';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericMaskInputComponent } from './generic-mask-input.component';

export * from './generic-mask-input.component';

@NgModule({
    declarations: [ GenericMaskInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        TranslateModule,
        GenericInputHintModule,
        MatInputModule,
        GenericInputSlotModule,
        GenericDirectivesModule,
        MatButtonModule,
        MatIconModule,
        MatAutocompleteModule,
        MatOptionModule,
        PipesModule,
    ],
    exports: [
        GenericMaskInputComponent,
    ],
})
export class GenericMaskInputModule {
}
